// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.test_result_import_source_enum */
var TestResultImportSourceEnum;
(function (TestResultImportSourceEnum) {
    TestResultImportSourceEnum["TABULAR"] = "TABULAR";
    TestResultImportSourceEnum["PDF"] = "PDF";
})(TestResultImportSourceEnum || (TestResultImportSourceEnum = {}));
;
export default TestResultImportSourceEnum;
/** Zod schema for test_result_import_source_enum */
export const testResultImportSourceEnum = z.nativeEnum(TestResultImportSourceEnum);
//# sourceMappingURL=TestResultImportSourceEnum.js.map